import type { ConstValues } from '@openx/types/helpers.ts';
export type PublisherAppDefaultUrlType = ConstValues<typeof PublisherAppDefaultUrl>;

export const PublisherAppDefaultUrl = {
  Creatives: '/ad-quality/creatives-management/new',
  Home: '/home',
  Publishers: '/inventory/publishers',
  Sites: '/inventory/sites',
} as const;

export type ApplicationDefaultUrlType = ConstValues<typeof ApplicationDefaultUrl>;

export const ApplicationDefaultUrl = {
  Dsp: '/dsp-ui',
  Publishers: PublisherAppDefaultUrl,
  Unity: '/unity',
} as const;

export const ApplicationPrefix = {
  Dsp: '/dsp-ui',
  Publisher: '/control',
  Unity: '/unity',
} as const;
